<template>
    <div class="sell-cards-mobile">
        <b-row>
            <b-col class="p-0">
                <swiper
                    class="swiper"
                    :options="swiperOption"
                    ref="swiper"
                >
                    <template
                        v-for="(card, index) in cards"
                    >
                        <swiper-slide
                            :key="index"
                            v-if="card.enabled"
                        >
                            <b-card
                                class="mobile-sell-card m-auto text-center"
                            >
                                <sell-card-header :card="card" />
                            </b-card>
                        </swiper-slide>
                    </template>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </b-col>
        </b-row>

        <b-row
            class="mt-4"
            v-if="renderContent"
        >
            <b-col class="d-flex">
                <sell-card-content
                    class="mx-auto"
                    :card="cards[currentSlideIndex]"
                />
            </b-col>
        </b-row>

        <sell-card-footer :card="cards[currentSlideIndex]" />
    </div>
</template>

<script>
    import './SellCardsMobile.scss';
    import 'swiper/swiper-bundle.css';
    import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
    import SellCardContent from "../SellCards/SellCard/SellCardContent/SellCardContent";
    import SellCardHeader from "../SellCards/SellCard/SellCardHeader/SellCardHeader";
    import SellCardFooter from "../SellCards/SellCard/SellCardFooter/SellCardFooter";

    export default {
        name: "SellCardsMobile",

        components: {
            SellCardFooter,
            SellCardHeader,
            SellCardContent,
            Swiper,
            SwiperSlide
        },

        data() {
            return {
                renderContent: true,
                currentSlideIndex: 0,
                swiperOption: {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 10,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    }
                }
            };
        },

        props: {
            cards: {
                type: Array,
                required: true,
            }
        },

        methods: {
            handleSlideChange(Swiper) {
                this.currentSlideIndex = Swiper.activeIndex;
            }
        },

        mounted() {
            let Swiper = this.$refs.swiper.$swiper;

            Swiper.on('slideChange', this.handleSlideChange);
        },

        watch: {
            currentSlideIndex() {
                this.renderContent = false;

                this.$nextTick(() => {
                    this.renderContent = true;
                });
            }
        }
    };
</script>
